import { Apartment } from '../apartments-finishing/apartments-finishing';
import { Button } from '../primitives/button/button';

interface ApartsmentFinishingItemProps {
  apartment: Apartment;
  handleApartmentClick: (item: Apartment) => void;
}

export const ApartmentsFinishingItem = ({
  apartment,
  handleApartmentClick,
}: ApartsmentFinishingItemProps) => {
  return (
    <div className="grid py-5 bg-plt-black/5 shadow-lg rounded-[20px] font-open-sans">
      <div className="w-full flex justify-center items-center h-[240px]">
        <img
          src={apartment.image}
          alt={apartment.title}
          className="object-scale-down w-full h-full"
        />
      </div>
      <h5 className="text-center text-plt-black font-semibold leading-[120%] mt-2">
        {apartment.title}
      </h5>
      <p className="text-center text-[#828081] text-xs font-semibold leading-[120%] mt-3">
        Жилая площадь: <span>{apartment.livingSpace}</span>
      </p>
      <div className='flex flex-col justify-center items-center'>
        <Button
          onClick={() => handleApartmentClick(apartment)}
          className="mt-6 font-semibold text-plt-white w-fit"
        >
          {apartment.price}

        </Button>
        <span className='relative text-[#8D8D8D] mt-2 font-light'>{apartment.oldPrice}
          <div className='absolute top-1/2 -translate-y-1/2 left-0 right-0 -rotate-6 h-px bg-[#8D8D8D]' /></span>
      </div>
    </div >
  );
};
